import React, { useState } from 'react'

const typeOf = (value) => {
  if (value === null) return 'null'
  if (Array.isArray(value)) return 'array'
  return typeof value
}

const JsonTreeNode = ({ label, value }) => {
  const [expanded, setExpanded] = useState(true)
  const type = typeOf(value)
  const isExpandable = type === 'object' || type === 'array'

  if (!isExpandable) {
    return (
      <div className="json-tree-row">
        {label && <span className="json-tree-key">{label}: </span>}
        <span className={`json-tree-value json-tree-${type}`}>
          {type === 'string' ? `"${value}"` : String(value)}
        </span>
      </div>
    )
  }

  const entries =
    type === 'array' ? value.map((v, i) => [i, v]) : Object.entries(value)

  return (
    <div className="json-tree-row">
      <button
        type="button"
        className="json-tree-toggle"
        onClick={() => setExpanded((current) => !current)}
      >
        {expanded ? '▾' : '▸'}
      </button>
      {label && <span className="json-tree-key">{label}: </span>}
      <span className="json-tree-bracket">
        {type === 'array' ? `[${entries.length}]` : `{${entries.length}}`}
      </span>
      {expanded && (
        <div className="json-tree-children">
          {entries.map(([key, child]) => (
            <JsonTreeNode label={key} value={child} key={key} />
          ))}
        </div>
      )}
    </div>
  )
}

export default JsonTreeNode
